import { render, staticRenderFns } from "./loyaltysettings.vue?vue&type=template&id=9fccccf2&scoped=true"
import script from "./loyaltysettings.vue?vue&type=script&lang=js"
export * from "./loyaltysettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fccccf2",
  null
  
)

export default component.exports